import React from "react";
import ReactTooltip from "react-tooltip";
import {Global, css} from "@emotion/react";
import {v4 as uuid} from "uuid";
import {CustomThemeContext} from "js/common/themes/CustomThemeProvider";

const TOOLTIP_CLASS = "c19-tooltip";

const tooltipGlobalStyles = css`
  .${TOOLTIP_CLASS} {
    opacity: 1 !important;
    padding: 8px 12px !important;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }
`;

const baseLabelStyle = {
  fontSize: "0.8rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "0.2rem",
  width: "fit-content"
};

const tooltipIconStyle = (theme) => ({
  cursor: "pointer",
  alignItems: "center",
  justifyContent: "center",
  marginLeft: 5,
  border: `1px solid ${theme.palette.primary.main}`,
  width: 14,
  height: 14,
  borderRadius: "50%",
  display: "flex"
});

const infoIconStyle = (theme) => ({
  color: theme.palette.primary.main,
  fontSize: "8px"
});

const tooltipTitleStyle = {
  display: "block",
  marginBottom: "4px",
  fontSize: "0.7rem",
  fontWeight: 500
};

const tooltipBodyStyle = {
  fontSize: "0.8rem",
  textTransform: "none",
  maxWidth: 300,
  margin: 0,
  padding: 0,
  lineHeight: 1.3
};

const TooltipLabel = React.memo(({label, tooltip, customLabelStyle, customTooltipStyle, children}) => {
  const {theme} = React.useContext(CustomThemeContext);
  const id = uuid();
  const labelTooltipId = "label-tooltip-" + id;

  return (
      <span style={{...baseLabelStyle, ...customLabelStyle}}>
        {label}
        {tooltip &&
            <div
                data-tip=""
                data-for={labelTooltipId}
                style={tooltipIconStyle(theme)}>
              <Global styles={tooltipGlobalStyles} />
              <i
                  className="fa fa-info"
                  style={infoIconStyle(theme)} />
              <ReactTooltip
                  className={TOOLTIP_CLASS}
                  textColor={theme.palette.text.main}
                  backgroundColor={theme.palette.background.card}
                  zIndex={9999999}
                  place="top"
                  effect="solid"
                  id={labelTooltipId}>
                <p style={{...tooltipBodyStyle, ...customTooltipStyle}}>
                  <span style={tooltipTitleStyle}>{label}</span>
                  {tooltip}
                </p>
              </ReactTooltip>
            </div>
        }
        {children}
      </span>
  );
});

export default TooltipLabel;
